export default __webpack_public_path__ + "static/media/desktop_bg.3f417240.jpg";